import { applyHighchartsTheme } from "../utils/highcharts_theme"

export const BrokerageIntelligenceChart = {
  mounted() {
    this.handleEvent("render-proposals-timeline", ({ chart_data }) => {
      this.renderChart(chart_data)
    })

    // Also render on mount if data is present
    const chartData = this.el.dataset.chart
    if (chartData) {
      this.renderChart(JSON.parse(chartData))
    }
  },

  renderChart(chartData) {
    import("highcharts").then((Highcharts) => {
      applyHighchartsTheme(Highcharts.default)
      Highcharts.default.chart(this.el.id, {
        chart: {
          type: "column",
          // Highcharts 13 defaults chart.backgroundColor to a CSS var that
          // renders dark under prefers-color-scheme: dark; keep it explicit.
          backgroundColor: "transparent",
        },
        title: {
          text: "Proposals Over Time",
        },
        xAxis: {
          categories: chartData.categories,
          title: {
            text: "Time Period",
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Number of Proposals",
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              color: "#333333",
            },
          },
        },
        legend: {
          align: "right",
          verticalAlign: "top",
          floating: true,
          backgroundColor: "white",
          borderColor: "#CCC",
          borderWidth: 1,
          shadow: false,
        },
        tooltip: {
          headerFormat: "<b>{point.key}</b><br/>",
          pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: false,
            },
          },
        },
        series: chartData.series,
        credits: {
          enabled: false,
        },
      })
    })
  },
}
